/* ===== TASTOCASA - WHATSAPP PER PREVENTIVO SPEDIZIONI > 51 EURO ===== */
document.addEventListener("DOMContentLoaded", function () {

  function checkShippingRates() {
    const whatsappBox = document.getElementById("WhatsappShippingQuote");

    if (!whatsappBox) return;

    const resultBox = document.querySelector(
      'calculate-shipping .form__message'
    );

    if (!resultBox) {
      whatsappBox.style.display = "none";
      return;
    }

    /*
     * CASO 1:
     * Nessuna spedizione disponibile /
     * indirizzo non servito.
     *
     * Il tema genera un box con classe:
     * .alert--error
     */
    const errorBox = resultBox.querySelector(".alert--error");

    if (errorBox) {
      whatsappBox.style.display = "";
      return;
    }

    /*
     * CASO 2:
     * Sono presenti una o più tariffe.
     */
    const rateItems = resultBox.querySelectorAll("li");

    if (!rateItems.length) {
      whatsappBox.style.display = "none";
      return;
    }

    const prices = [];

    rateItems.forEach(function (item) {
      const text = item.textContent.trim();

      /*
       * Il tema stampa ad esempio:
       * "Spedizione Standard: EUR 12.50"
       */
      const match = text.match(
        /(?:EUR|€)\s*([0-9]+(?:[.,][0-9]{1,2})?)/i
      );

      if (match) {
        const price = parseFloat(
          match[1].replace(",", ".")
        );

        if (!isNaN(price)) {
          prices.push(price);
        }
      }
    });

    /*
     * Se non troviamo nessun prezzo valido,
     * il box WhatsApp resta nascosto.
     */
    if (!prices.length) {
      whatsappBox.style.display = "none";
      return;
    }

    /*
     * Prendiamo la tariffa più economica disponibile.
     */
    const lowestPrice = Math.min.apply(null, prices);

    /*
     * Mostriamo WhatsApp solo se
     * la tariffa più economica supera 51 €.
     */
    whatsappBox.style.display =
      lowestPrice > 51 ? "" : "none";
  }


  /*
   * Osserviamo il DOM perché il cart drawer
   * e il risultato della spedizione vengono
   * aggiornati dinamicamente da Shopify/FoxTheme.
   */
  const observer = new MutationObserver(function (mutations) {

    let shouldCheck = false;

    mutations.forEach(function (mutation) {
      if (
        mutation.target.closest?.("calculate-shipping") ||
        mutation.target.querySelector?.("calculate-shipping")
      ) {
        shouldCheck = true;
      }
    });

    if (shouldCheck) {
      checkShippingRates();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  /*
   * Controllo iniziale.
   */
  checkShippingRates();

});

/* =========================================================
   TASTOCASA - POPUP AVVISO PRODOTTI COMPONIBILI
   Mostrato solo sui prodotti la cui descrizione contiene
   l'avviso "Per ottenere l'articolo come in Foto..."
   ========================================================= */
document.addEventListener("DOMContentLoaded", function () {

  /* Solo nelle pagine prodotto */
  if (!window.location.pathname.includes("/products/")) {
    return;
  }

  /* Cerchiamo il blocco descrizione prodotto */
  const descriptionBlock = document.querySelector(
    ".product__block--description, .product__description, [class*='product-description']"
  );

  if (!descriptionBlock) {
    return;
  }

  /* Normalizziamo il testo per il controllo */
  const descriptionText = descriptionBlock.textContent
    .toLowerCase()
    .replace(/\s+/g, " ")
    .trim();

  /*
   * Il popup viene mostrato solamente quando nella descrizione
   * troviamo il messaggio tipico dei prodotti componibili.
   */
  const isComponibile =
    descriptionText.includes("per ottenere") &&
    descriptionText.includes("come in foto") &&
    descriptionText.includes("acquist");

  if (!isComponibile) {
    return;
  }

  /* Evita eventuali duplicazioni */
  if (document.getElementById("TastocasaComponibilePopup")) {
    return;
  }

  /* ==========================
     CSS POPUP
     ========================== */

  const style = document.createElement("style");

  style.textContent = `
    #TastocasaComponibilePopup {
      position: fixed;
      inset: 0;
      z-index: 999999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;
    }

    #TastocasaComponibilePopup .tc-popup-overlay {
      position: absolute;
      inset: 0;
      background: rgba(0, 0, 0, 0.55);
      backdrop-filter: blur(2px);
      -webkit-backdrop-filter: blur(2px);
    }

    #TastocasaComponibilePopup .tc-popup-box {
      position: relative;
      z-index: 2;
      width: 100%;
      max-width: 520px;
      background: #ffffff;
      border-radius: 18px;
      padding: 34px 32px 30px;
      box-shadow: 0 15px 50px rgba(0, 0, 0, 0.22);
      text-align: center;
    }

    #TastocasaComponibilePopup .tc-popup-icon {
      width: 55px;
      height: 55px;
      margin: 0 auto 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      background: #fff3e6;
      font-size: 28px;
    }

    #TastocasaComponibilePopup .tc-popup-title {
      margin: 0 0 14px;
      font-size: 23px;
      line-height: 1.25;
      font-weight: 700;
      color: #000000;
    }

    #TastocasaComponibilePopup .tc-popup-text {
      margin: 0;
      font-size: 16px;
      line-height: 1.6;
      color: #333333;
    }

    #TastocasaComponibilePopup .tc-popup-text strong {
      color: #000000;
      font-weight: 700;
    }

    #TastocasaComponibilePopup .tc-popup-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-top: 24px;
      padding: 14px 22px;
      border: 0;
      border-radius: 10px;
      background: #000000;
      color: #ffffff;
      font-size: 15px;
      line-height: 1;
      font-weight: 600;
      cursor: pointer;
      transition:
        transform 0.2s ease,
        opacity 0.2s ease;
    }

    #TastocasaComponibilePopup .tc-popup-button:hover {
      opacity: 0.88;
      transform: translateY(-1px);
    }

    #TastocasaComponibilePopup .tc-popup-close {
      position: absolute;
      top: 14px;
      right: 16px;
      width: 36px;
      height: 36px;
      padding: 0;
      border: 0;
      background: transparent;
      color: #555555;
      font-size: 27px;
      line-height: 36px;
      cursor: pointer;
    }

    body.tc-popup-open {
      overflow: hidden;
    }

    @media screen and (max-width: 749px) {

      #TastocasaComponibilePopup {
        padding: 16px;
      }

      #TastocasaComponibilePopup .tc-popup-box {
        max-width: 100%;
        padding: 30px 22px 24px;
        border-radius: 15px;
      }

      #TastocasaComponibilePopup .tc-popup-title {
        font-size: 20px;
      }

      #TastocasaComponibilePopup .tc-popup-text {
        font-size: 15px;
      }

    }
  `;

  document.head.appendChild(style);

  /* ==========================
     CREAZIONE POPUP
     ========================== */

  const popup = document.createElement("div");

  popup.id = "TastocasaComponibilePopup";

  popup.innerHTML = `
    <div class="tc-popup-overlay"></div>

    <div
      class="tc-popup-box"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tcPopupTitle"
    >

      <button
        type="button"
        class="tc-popup-close"
        aria-label="Chiudi avviso"
      >
        &times;
      </button>

      <div class="tc-popup-icon" aria-hidden="true">
        ⚠️
      </div>

      <h2
        id="tcPopupTitle"
        class="tc-popup-title"
      >
        Attenzione: prodotto componibile
      </h2>

      <p class="tc-popup-text">
        L'immagine può mostrare una composizione completa ottenuta
        acquistando più articoli separatamente.
        <br><br>
        <strong>
          Prima di procedere con l'acquisto, leggi attentamente
          la descrizione del prodotto
        </strong>
        per verificare quali componenti sono inclusi e quali devono
        essere acquistati a parte.
      </p>

      <button
        type="button"
        class="tc-popup-button"
      >
        Leggi la descrizione
      </button>

    </div>
  `;

  document.body.appendChild(popup);
  document.body.classList.add("tc-popup-open");

  const closeButton = popup.querySelector(".tc-popup-close");
  const descriptionButton = popup.querySelector(".tc-popup-button");
  const overlay = popup.querySelector(".tc-popup-overlay");

  /* ==========================
     CHIUSURA POPUP
     ========================== */

  function closePopup() {
    document.body.classList.remove("tc-popup-open");
    popup.remove();
  }

  closeButton.addEventListener("click", function () {
    closePopup();
  });

  overlay.addEventListener("click", function () {
    closePopup();
  });

  /* ==========================
     VAI ALLA DESCRIZIONE
     ========================== */

  descriptionButton.addEventListener("click", function () {

    closePopup();

    setTimeout(function () {

      descriptionBlock.scrollIntoView({
        behavior: "smooth",
        block: "center"
      });

    }, 150);

  });

  /* Chiusura anche con ESC */
  document.addEventListener("keydown", function handleEscape(event) {

    if (event.key === "Escape") {
      closePopup();
      document.removeEventListener("keydown", handleEscape);
    }

  });

});

/* ==========================================================
   TASTOCASA - POPUP OFFERTA A TEMPO
   Mostrato una sola volta per sessione
========================================================== */

document.addEventListener("DOMContentLoaded", function () {

  const popupSessionKey = "tastocasa-offer-popup-shown";

  // Se è già stato mostrato durante questa sessione, non fare nulla
  if (sessionStorage.getItem(popupSessionKey)) {
    return;
  }

  // Segna subito il popup come mostrato
  sessionStorage.setItem(popupSessionKey, "true");

  /* =========================
     CSS
  ========================= */

  const style = document.createElement("style");

  style.innerHTML = `
    .tastocasa-offer-popup-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0, 0, 0, 0.55);
      z-index: 999999999;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 20px;

      opacity: 0;
      visibility: hidden;
      transition:
        opacity 0.3s ease,
        visibility 0.3s ease;
    }

    .tastocasa-offer-popup-overlay.is-visible {
      opacity: 1;
      visibility: visible;
    }

    .tastocasa-offer-popup {
      position: relative;

      width: 100%;
      max-width: 780px;

      background: #ffffff;
      border-radius: 24px;
      overflow: hidden;

      display: grid;
      grid-template-columns: 1fr 1fr;

      box-shadow:
        0 20px 60px rgba(0, 0, 0, 0.20);

      transform: translateY(20px) scale(0.98);
      transition: transform 0.3s ease;
    }

    .tastocasa-offer-popup-overlay.is-visible
    .tastocasa-offer-popup {
      transform: translateY(0) scale(1);
    }

    /* =========================
       IMMAGINE
    ========================= */

    .tastocasa-offer-popup__image {
      width: 100%;
      height: 100%;
      min-height: 430px;
      object-fit: cover;
      display: block;
    }

    /* =========================
       CONTENUTO
    ========================= */

    .tastocasa-offer-popup__content {
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 42px 38px;
    }

    .tastocasa-offer-popup__label {
      display: inline-flex;
      align-self: flex-start;

      margin-bottom: 15px;
      padding: 7px 14px;

      background: #A4D33B;
      color: #000000;

      font-size: 12px;
      font-weight: 700;
      line-height: 1;

      border-radius: 50px;

      text-transform: uppercase;
      letter-spacing: 0.5px;
    }

    .tastocasa-offer-popup__title {
      margin: 0 0 15px;

      color: #000000;

      font-size: 32px;
      font-weight: 700;
      line-height: 1.1;
    }

    .tastocasa-offer-popup__text {
      margin: 0 0 25px;

      color: #555555;

      font-size: 16px;
      line-height: 1.55;
    }

    .tastocasa-offer-popup__text strong {
      color: #000000;
      font-weight: 700;
    }

    /* =========================
       PULSANTE
    ========================= */

    .tastocasa-offer-popup__button {
      width: 100%;

      border: 0;
      border-radius: 12px;

      padding: 15px 20px;

      background: #FF5C2B;
      color: #ffffff;

      font-family: inherit;
      font-size: 15px;
      font-weight: 700;

      cursor: pointer;

      transition:
        transform 0.2s ease,
        background-color 0.2s ease;
    }

    .tastocasa-offer-popup__button:hover {
      background: #e94e20;
      transform: translateY(-1px);
    }

    /* =========================
       CHIUSURA
    ========================= */

    .tastocasa-offer-popup__close {
      position: absolute;
      top: 14px;
      right: 14px;

      width: 38px;
      height: 38px;

      padding: 0;
      border: 0;
      border-radius: 50%;

      display: flex;
      align-items: center;
      justify-content: center;

      background: rgba(255, 255, 255, 0.92);
      color: #000000;

      font-size: 25px;
      line-height: 1;

      cursor: pointer;

      z-index: 2;

      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
    }

    .tastocasa-offer-popup__close:hover {
      background: #ffffff;
    }

    /* =========================
       MOBILE
    ========================= */

    @media (max-width: 749px) {

      .tastocasa-offer-popup-overlay {
        padding: 15px;
      }

      .tastocasa-offer-popup {
        display: block;
        max-width: 440px;
        border-radius: 20px;

        max-height: calc(100vh - 30px);
        overflow-y: auto;
      }

      .tastocasa-offer-popup__image {
        width: 100%;
        height: auto;
        min-height: 0;

        aspect-ratio: 1 / 0.78;
        object-fit: cover;
      }

      .tastocasa-offer-popup__content {
        padding: 27px 24px 25px;
        text-align: center;
      }

      .tastocasa-offer-popup__label {
        align-self: center;
        margin-bottom: 12px;
      }

      .tastocasa-offer-popup__title {
        font-size: 26px;
        margin-bottom: 12px;
      }

      .tastocasa-offer-popup__text {
        font-size: 14px;
        line-height: 1.5;
        margin-bottom: 20px;
      }
    }
  `;

  document.head.appendChild(style);


  /* =========================
     HTML POPUP
  ========================= */

  const overlay = document.createElement("div");

  overlay.className = "tastocasa-offer-popup-overlay";

  overlay.innerHTML = `
    <div
      class="tastocasa-offer-popup"
      role="dialog"
      aria-modal="true"
      aria-labelledby="tastocasa-popup-title"
    >

      <button
        type="button"
        class="tastocasa-offer-popup__close"
        aria-label="Chiudi popup"
      >
        &times;
      </button>

      <div class="tastocasa-offer-popup__media">
        <img
          class="tastocasa-offer-popup__image"
          src="https://cdn.shopify.com/s/files/1/0965/0238/2920/files/qualita-affidabile.png?v=1780999937"
          alt="Prodotti per bagno e casa Tastocasa"
          loading="eager"
        >
      </div>

      <div class="tastocasa-offer-popup__content">

        <span class="tastocasa-offer-popup__label">
          Offerta a tempo
        </span>

        <h2
          id="tastocasa-popup-title"
          class="tastocasa-offer-popup__title"
        >
          Approfittane ora!
        </h2>

        <p class="tastocasa-offer-popup__text">
          Tutti i nostri prodotti sono in offerta per un periodo limitato.
          <strong>
            Non perdere l'occasione di acquistare al miglior prezzo.
          </strong>
        </p>

        <button
          type="button"
          class="tastocasa-offer-popup__button"
        >
          Scopri le offerte
        </button>

      </div>

    </div>
  `;

  document.body.appendChild(overlay);


  /* =========================
     APERTURA
  ========================= */

  setTimeout(function () {

    overlay.classList.add("is-visible");

    document.body.style.overflow = "hidden";

  }, 700);


  /* =========================
     CHIUSURA
  ========================= */

  function closeOfferPopup() {

    overlay.classList.remove("is-visible");

    document.body.style.overflow = "";

    setTimeout(function () {

      if (overlay.parentNode) {
        overlay.remove();
      }

    }, 300);
  }


  const closeButton = overlay.querySelector(
    ".tastocasa-offer-popup__close"
  );

  const offerButton = overlay.querySelector(
    ".tastocasa-offer-popup__button"
  );


  closeButton.addEventListener("click", closeOfferPopup);

  offerButton.addEventListener("click", closeOfferPopup);


  /* Chiude cliccando sullo sfondo */

  overlay.addEventListener("click", function (event) {

    if (event.target === overlay) {
      closeOfferPopup();
    }

  });


  /* Chiude con ESC */

  document.addEventListener("keydown", function escHandler(event) {

    if (event.key === "Escape") {

      closeOfferPopup();

      document.removeEventListener("keydown", escHandler);
    }

  });

});